export default __webpack_public_path__ + "static/media/grafana.f06f319e.svg";